export default "__VITE_ASSET__whpthjD___"